export const ContactSubType = {
    HOME: 'HOME',
    WORK: 'WORK',
    TEMPORARY: 'TEMPORARY',
    MOBILE: 'MOBILE',
};

export type TContactSubType = typeof ContactSubType[keyof typeof ContactSubType];
